import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import {
    productCheckListFiltersQuerySchema,
    ProductCheckListPage,
} from '@mews-commander/modules/src/modules/productCheckList';
import { MewsTeam, RouteType } from '@mews/enums';

const Component: React.FC = () => (
    <ProductCheckListPage guideLink={createGuideLink(ArticlePath.ProductChecklist)} searchParams={Route.useSearch()} />
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/ProductCheckList/Index/')({
    validateSearch: productCheckListFiltersQuerySchema,
    component: Component,
    staticData: {
        routeName: RouteName.ProductCheckListIndex,
        owner: MewsTeam.Reservations,
        type: RouteType.Frontend,
        title: TextKey.ProductCheckList,
    },
});
